import { ICardData } from "../@types/interface.d";

export default class CardData {
  private card: ICardData;

  public opened: boolean = false;

  public selected: boolean = false;

  constructor(card: ICardData, opened: boolean = false) {
    this.card = card;
    this.opened = opened;
  }

  public get id() { return this.card.id; }

  public get tags() { return this.card.tags; }

  public get imageUrl() { return this.card.imageUrl; }

  public get originUrl() { return this.card.originUrl; }

  public get tagId() { return this.card.tags[0]?.id; }

  public get tagName() { return this.card.tags[0]?.name; }

  public get height() { return this.card.height; }

  public get width() { return this.card.width; }
}
